export default __webpack_public_path__ + "static/media/ViewIcon.486bc57c.svg";